// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"698093f9","478":"8c0c2d1c","767":"f35de065"}[chunkId] + ".chunk.css";
};